
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,

    USER_LOGOUT,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_RESET,

    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_RESET,

    USER_DELETE_REQUEST,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,


} from '../constants/userConstants'


export const userLoginReducer = (state = {loading:false,
    error:null,
    success:false,
    todoUserInfo:{},
}, action) => {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return { loading: true ,todoUserInfo:{}, success:false,error:null}

        case USER_LOGIN_SUCCESS:
            return { loading: false, todoUserInfo: action.payload , success:true}

        case USER_LOGIN_FAIL:
            return { loading: false, error: action.payload,todoUserInfo:{}, success:false }

        case USER_LOGOUT:
            return {loading:false,
                error:null,
                success:false,
                todoUserInfo:{},}

        default:
            return state
    }
}



export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_REGISTER_REQUEST:
            return { loading: true, error:'' }

        case USER_REGISTER_SUCCESS:
            return { loading: false, todoUserInfo: action.payload, error:'',
                success:true,
            }

        case USER_REGISTER_FAIL:
            return { loading: false, error: action.payload ,success:false,}

        case USER_LOGOUT:
            return {}

        default:
            return state
    }
}



export const userDetailsReducer = (state = {
    user: {},
    loading: false,
    error: null,
    success:false,
}, action) => {
    switch (action.type) {
        case USER_DETAILS_REQUEST:
            return { ...state, loading: true}

        case USER_DETAILS_SUCCESS:
            return { loading: false, user: action.payload, error: null,
                success:true, }

        case USER_DETAILS_FAIL:
            return { loading: false, user: {}, error: action.payload,
            success:false, }

        case USER_DETAILS_RESET:
            return {
                user: {},
                loading: false,
                error: null,
                success:true,
            }


        default:
            return state
    }
}


export const userUpdateProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_UPDATE_PROFILE_REQUEST:
            return { loading: true }

        case USER_UPDATE_PROFILE_SUCCESS:
            return { loading: false, success: true, todoUserInfo: action.payload }

        case USER_UPDATE_PROFILE_FAIL:
            return { loading: false, error: action.payload }

        case USER_UPDATE_PROFILE_RESET:
            return {}

        default:
            return state
    }
}


export const userListReducer = (state = {
    users: [],
    loading: false,
    error: ""
}, action) => {
    switch (action.type) {
        case USER_LIST_REQUEST:
            return { users: [], loading: true, error: "" }

        case USER_LIST_SUCCESS:
            return { users: action.payload, loading: false, error: "" }

        case USER_LIST_FAIL:
            return { users: [], loading: false, error: action.payload }

        case USER_LIST_RESET:
            return {
                users: [],
                loading: false,
                error: ""
            }

        default:
            return state
    }
}


export const userDeleteReducer = (state = {loading: false, success: false}, action) => {
    switch (action.type) {
        case USER_DELETE_REQUEST:
            return { loading: true, success: false }

        case USER_DELETE_SUCCESS:
            return { loading: false, success: true }

        case USER_DELETE_FAIL:
            return { loading: false, error: action.payload,success: false }

        default:
            return state
    }
}


